<template>
	<b-container
		class="p-0"
		fluid
	>
		<b-row
			class="header"
		>
			<b-col
				class="text-center text-md-left"
				md="5"
			>
				<router-link
					class="brand-logo"
					to="/secure"
				>
					<img
						:src="require('@/assets/logo.png')"
						width="120"
					>
				</router-link>
				<span class="sub-heading">Moving Quote Calculator</span>
			</b-col>
			<b-col
				class="text-center text-md-left"
				md="7"
			>
				<p class="tag-line">
					Move for as low as $399 depending on destination.<br />Save up to 50%!
				</p>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	name: 'AppHeader',
};
</script>

<style scoped lang="scss">
@import "~@/../node_modules/bootstrap/scss/bootstrap-reboot";

.header {
	align-items: center;
	background: white;
	margin: 0 auto;
	padding: 1rem 1.25rem;

	// > div {
	//
	// 	flex-direction: column;
	// }

	> * {
		line-height: 1;
		padding: 0;
	}

	.brand-logo {
		padding: 0 0.75rem 0 0;

		img {
			width: 120px;
		}
	}

	.sub-heading {
		border-left: none;
		display: inline-block;
		font-size: 1.1rem;
		font-weight: 500;
		padding: 0.625rem 0 0.375rem;
		vertical-align: middle;
	}

	.tag-line {
		font-size: 1.1rem;
		font-weight: 500;
		line-height: 1.25;
		margin: 0.5rem 0;
		text-align: center;
	}

	@include media-breakpoint-up(md) {
		.sub-heading {
			border-left: 1px solid #4c4c4c;
			font-size: 1.2rem;
			padding: 0.375rem 0.75rem;
		}

		.tag-line {
			font-size: 1.2rem;
			text-align: right;
		}
	}
}
</style>
